// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__HHOzJ"};